import React from 'react'

function How() {
  return (
    <div>How</div>
  )
}

export default How